import { modifyAndMaintainFocus } from '@app/utils/domHelpers'
import { SfTime } from '@app/adapters/time'
import {
  addIcon,
  removeIcon,
} from '@app/application/reconciliation/handlers/shared/utils'

export const showValidationError = (
  input: HTMLInputElement,
  error: string
): void => {
  if (input.getAttribute('data-input-invalid') === 'true') {
    return
  }

  modifyAndMaintainFocus(() => {
    window.requestAnimationFrame(() => {
      addIcon(input, 'validation', error)
    })
  }, input)

  input.classList.add('sf-required')
  input.setAttribute('data-input-invalid', 'true')
}

export const hideValidationError = (input: HTMLInputElement): void => {
  modifyAndMaintainFocus(() => {
    window.requestAnimationFrame(() => {
      removeIcon(input, 'validation')
    })
  }, input)

  input.classList.remove('sf-required')
  input.removeAttribute('data-input-invalid')
}

export const parseDateValue = (date: string, format: string): Date | null => {
  if (!date || !date.trim()) {
    return null
  }

  const momentDate = SfTime(date, format)
  if (!momentDate.isValid()) {
    return null
  }

  return momentDate.toDate()
}

const hasDefinedRules = (rules: unknown, ruleNames: string[]): boolean => {
  const r = rules as Record<string, unknown>
  return (
    r &&
    ruleNames.some(
      (ruleName) => r[ruleName] !== null && r[ruleName] !== undefined
    )
  )
}

export const isDateRangeRules = (rules: unknown): boolean => {
  return hasDefinedRules(rules, ['start_date', 'end_date'])
}

export const isNumericRules = (rules: unknown): boolean => {
  return hasDefinedRules(rules, [
    'min',
    'max',
    'min_exclusive',
    'max_exclusive',
  ])
}

export const isStringLengthRules = (rules: unknown): boolean => {
  return hasDefinedRules(rules, ['min_length', 'max_length'])
}

export const isRegexpRules = (rules: unknown): boolean => {
  return hasDefinedRules(rules, ['pattern', 'validation_text', 'pattern_flags'])
}
